import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { WHATSAPP_URL } from '../data/oferta';
export function WhatsAppFloat() {
  return <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Escribir por WhatsApp si tienes dudas sobre el pago" className="group fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-full bg-[#25D366] px-4 py-3.5 text-violet-deep shadow-lg shadow-black/30 transition-transform duration-200 ease-out hover:scale-[1.03] focus:outline-none focus-visible:ring-2 focus-visible:ring-bone sm:px-5" data-id="element-129" data-mp="2et3z2g95fdbq">
      <MessageCircleIcon className="h-6 w-6 flex-none" aria-hidden="true" data-id="element-130" data-mp="2stn89qpcopfh" />
      <span className="hidden font-sans text-sm font-semibold sm:inline" data-id="element-131" data-mp="2nv3gh9o2sjf7">
        ¿Dudas con el pago?
      </span>
    </a>;
}